import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'container']

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isOpen()) {
      this.hide(null)
      return
    }

    this.show()
  }

  show() {
    this.buttonTarget.setAttribute('aria-expanded', 'true');
    const growableContainingAction = this.findGrowable();

    this.containerTarget.style.display = 'initial';
    if (growableContainingAction) {
      const containerRect = this.containerTarget.getBoundingClientRect();
      const growableRect = growableContainingAction.getBoundingClientRect();

      if (containerRect.bottom > growableRect.bottom) {
        const overflow = containerRect.bottom - growableRect.bottom;
        const currentHeight = growableContainingAction.offsetHeight;
        growableContainingAction.style.height = `${currentHeight + overflow}px`;
      }
    }
  }

  findGrowable() {
    const growables = document.getElementsByClassName('grow-on-action');
    let growableContainingAction = null;
    for (const growable of growables) {
      if (growable.contains(this.containerTarget)) {
          growableContainingAction = growable;
          break;
      }
    }
    return growableContainingAction;
  }

  hide(event) {
    if (this.isOwnTarget(event)) {
      return
    }

    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.containerTarget.style.display = 'none'
    this.resetGrowableHeight();
  }

  resetGrowableHeight() {
    const growableContainingAction = this.findGrowable();

    if (growableContainingAction) {
      growableContainingAction.style.height = 'initial';
    }
  }

  isOpen() {
    return this.buttonTarget.getAttribute('aria-expanded') === "true"
  }

  isOwnTarget(event) {
    return event && (this.containerTarget.contains(event.target) || this.buttonTarget.contains(event.target))
  }
}
